import { Type } from 'class-transformer';
import { CurrentSampleOrderStatus } from 'types/models/samples/CurrentSampleOrderStatus';
import { Nullable } from '@cast/leadcast-types';
import { SampleProperty } from './SampleProperty';
import { SamplingKit } from './SamplingKit';
import { SamplingProgram } from './SamplingProgram';
import { TapSampleForm } from './TapSampleForm';
import { CASTFile } from '../CASTFile';
import { Sample } from './Sample';

export interface ScannedSampleInfoForm {
  bucketLocation: string;
  bucketName: Nullable<string>;
  fileName: string;
  id: string;
  mimeType: string;
  url: string;
  file: CASTFile;
}

export interface SamplingEvent {
  id: number;
  startDate: Date;
  endDate: Date;
  name: Nullable<string>;
  description: Nullable<string>;
  createdOn: Date;
  createdBy: string;
  lastModifiedOn: Date;
  lastModifiedBy: string;
  sampleOrderId: string;
  externalId: string;
  pdfReportId: string;
  pdfReportFile: CASTFile;
  monitoringProgramId: number;
  monitoringProgram?: SamplingProgram;
  samples?: Sample[];
  tapSampleForm: Nullable<TapSampleForm>;
  scannedSampleInfoForms?: ScannedSampleInfoForm[];
}

export interface SampleOrder {
  id: string;
  externalId: Nullable<string>;
  address: string;
  addressUnit: Nullable<string>;
  city: string;
  state: string;
  zipcode: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  currentSampleOrderStatus: CurrentSampleOrderStatus;
  sampleOrderStatuses: CurrentSampleOrderStatus[];
  property: SampleProperty;
  quantity: number;
  samplingKit: SamplingKit;
  samplingProgram: SamplingProgram;
  samplingProgramId: string;
  samplingEvents?: SamplingEvent[];
}

export class SampleOrder {
  @Type(() => CurrentSampleOrderStatus)
  currentSampleOrderStatus: CurrentSampleOrderStatus;
}
